import React from "react";
// Styles
import { withStyles } from "@material-ui/core/styles";
import { styles } from "../../styles";
// Material components
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

class ReportBugForm extends React.Component {
  state = {
    summary: "",
    description: "",
    environment: ""
  };

  handleChange = e => {
    this.setState({
      [e.target.id]: e.target.value
    });
  };

  render() {
    const { classes } = this.props;
    const { summary, description, environment } = this.state;

    return (
      <div className={classes.rightSidebar}>
        <Typography variant="h4">Report a Bug</Typography>
        <form noValidate autoComplete="off">
          <TextField
            id="summary"
            label="Summary"
            value={summary}
            onChange={this.handleChange}
            margin="normal"
            variant="outlined"
            className={classes.bugTextField}
          />
          <TextField
            id="description"
            label="Description"
            multiline
            rows="4"
            value={description}
            onChange={this.handleChange}
            className={classes.bugTextField}
            margin="normal"
            variant="outlined"
          />
          <TextField
            id="environment"
            label="Environment"
            multiline
            rows="2"
            value={environment}
            onChange={this.handleChange}
            className={classes.bugTextField}
            margin="normal"
            variant="outlined"
          />
          <Button color="primary">Submit</Button>
        </form>
      </div>
    );
  }
}

export default withStyles(styles)(ReportBugForm);
